import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ProvidersUIHelpers";

const ProviderssUIContext = createContext();

export function useProvidersUIContext() {
  return useContext(ProviderssUIContext);
}

export const ProvidersUIConsumer = ProviderssUIContext.Consumer;

export function ProvidersUIProvider({ providersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams, 
    openDetailProviderPage: providersUIEvents.openDetailProviderPage,
    openProviderEditStatusDialog:providersUIEvents.openProviderEditStatusDialog
  };

  return (
    <ProviderssUIContext.Provider value={value}>
      {children}
    </ProviderssUIContext.Provider>
  );
}
